interface TradingPhotoCardSkeletonProps {
  count?: number;
  showPrice?: boolean;
}

const TradingPhotoCardSkeleton = ({ count = 6, showPrice }: TradingPhotoCardSkeletonProps) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-[11px] gap-y-[28px] justify-items-center">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="w-full max-w-[160px] flex flex-col gap-[10px] animate-pulse">
          <div className="relative px-[48px] py-[29px] bg-separator1 rounded-[12px]">
            <div
              className="w-[63px] h-[100px] mx-auto rounded-[8px] 
              bg-gradient-to-r from-gray-200 to-gray-300 
              dark:from-gray-700 dark:to-gray-800"
            />
            <div
              className="w-[18px] h-[18px] rounded-full 
              bg-gradient-to-r from-gray-200 to-gray-300 
              dark:from-gray-700 dark:to-gray-800 absolute top-[5px] right-[5px]"
            />
          </div>

          <div className="flex flex-col gap-[6px] px-[4px]">
            <div className="h-4 rounded w-1/2 bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-800" />
            <div className="h-4 rounded w-1/3 bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-800" />
            {showPrice && (
              <div className="h-4 rounded w-1/2 bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-800" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TradingPhotoCardSkeleton;
